import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Currency } from '../models/currency.model';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {

    constructor(
        private http: HttpClient,
    ) { }

    getCurrency() {
        return this.http.get<Currency[]>(`/monedas`);
    }
}
